// Where a merchant notification opens (FR-B16 inbox, the bell popover). The API sends
// each item's subject as `entity_ref` ('booking:BK-…', 'thread:…', …); `action_url`
// (API-68) is used first when the server provides one. Mirrors the customer
// dashboard's notificationTarget, mapped onto the merchant routes — the bookings page
// opens its drawer from `?b=<code>` and the inbox its conversation from `?t=<id>`.
// Unknown kinds return null: the click marks the item read and closes the popover
// rather than guessing a page (AP-D10).
export function notificationTarget(entityRef: string | undefined, actionUrl?: string): string | null {
  if (actionUrl && actionUrl.startsWith('/')) return actionUrl;
  if (!entityRef) return null;
  const i = entityRef.indexOf(':');
  const kind = i === -1 ? entityRef : entityRef.slice(0, i);
  const id = i === -1 ? '' : entityRef.slice(i + 1);
  switch (kind) {
    case 'booking':
      return id ? `/bookings?b=${encodeURIComponent(id)}` : '/bookings';
    case 'thread':
    case 'message':
      return id && kind === 'thread' ? `/inbox?t=${encodeURIComponent(id)}` : '/inbox';
    case 'offer':
      return '/offers';
    case 'catalog_item':
    case 'catalog':
      return '/services';
    case 'review':
      return id ? `/services?tab=reviews&review=${encodeURIComponent(id)}` : '/services?tab=reviews';
    case 'business':
      // My Business lands on the list now; a notice about one business opens it.
      return id ? `/business?b=${encodeURIComponent(id)}` : '/business';
    case 'location_suggestion':
    case 'claim':
    case 'application':
      return '/business';
    case 'subscription':
    case 'subscription_payment':
      return '/plan';
    case 'staff':
      return '/team';
    default:
      return null;
  }
}
